const permissions = {
  listDrivers: 'DR001',
  addDriver: 'DR002',
  editDriver: 'DR003',
  removeDriver: 'DR004',
  massAssignment: 'OP001'
};

export default permissions;
